import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleDown, faArrowCircleUp } from '@fortawesome/free-solid-svg-icons';
interface TableHeaderProps {
  headerGroups: any;
}

export const TableHeader: React.FC<TableHeaderProps> = ({headerGroups}): JSX.Element => {
  return (
    <React.Fragment>
      <thead>
        {headerGroups.map((headerGroup: any, i) => (
          <tr key={i} {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column: any, ci) => { // PCDataTableColumnProps
              const icon = column.isSortedDesc ? faArrowCircleDown : faArrowCircleUp;
              const header = column.render('Header');
              // WAI do not render empty th elements
              // @ts-ignore
              if(column?.originalId && (column.originalId as string).endsWith('_placeholder')) {
                return <td key={`ch${ci}`}></td>
              }
              // render custom 'Header' componets or only text of header              
              if( typeof header === 'string' || header instanceof String) { 
                return (
                  <th {...column.getHeaderProps(column.getSortByToggleProps({ title: 'Sortierung ändern'}))} key={`ch${ci}`}>
                  {column.isSorted &&
                    <React.Fragment>
                      <span>{column.sortedIndex + 1}</span>
                        {'\u00A0'}
                        <FontAwesomeIcon icon={icon} size="sm" />
                        {'\u00A0'}
                      </React.Fragment>
                    }
                    {header}
                </th>
                );
              } else {
                return (<th {...column.getHeaderProps()} key={`ch${ci}`}>
                  {header}
                </th>);
              }
            })}
          </tr>
        ))}
      </thead>
    </React.Fragment>
  );
}
